import axios from "axios";

const state = {
  ingresos: [],
  categoriasIngreso: [],
};

const mutations = {
  SET_INGRESOS(state, items) { state.ingresos = items; },
  ADD_INGRESO(state, item) { state.ingresos.unshift(item); },
  UPDATE_INGRESO(state, item) {
    const idx = state.ingresos.findIndex((x) => x.id === item.id);
    if (idx !== -1) state.ingresos.splice(idx, 1, item);
  },
  DELETE_INGRESO(state, id) {
    state.ingresos = state.ingresos.filter((x) => x.id !== id);
  },
  SET_CATEGORIAS_INGRESO(state, items) { state.categoriasIngreso = items; },
};

const actions = {
  async fetchIngresosExtra({ commit }, params = {}) {
    const { data } = await axios.get("/api/ingreso", { params });
    commit("SET_INGRESOS", data);
    return data;
  },
  async getIngresoById(_, id) {
    const { data } = await axios.get(`/api/ingreso/${id}`);
    return data;
  },
  async guardarIngreso({ commit }, payload) {
    const { data } = await axios.post("/api/ingreso", payload);
    commit("ADD_INGRESO", data);
    return data;
  },
  async updateIngreso({ commit }, payload) {
    const { data } = await axios.put(`/api/ingreso/${payload.id}`, payload);
    commit("UPDATE_INGRESO", data);
    return data;
  },
  async deleteIngreso({ commit }, id) {
    await axios.delete(`/api/ingreso/${id}`);
    commit("DELETE_INGRESO", id);
  },
  async fetchCategoriasIngreso({ commit }) {
    const { data } = await axios.get("/api/categoria-ingreso");
    commit("SET_CATEGORIAS_INGRESO", data);
    return data;
  },
};

const getters = {
  ingresosExtra: (state) => state.ingresos,
  categoriasIngreso: (state) => state.categoriasIngreso,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
